/**
 * ComparisonSiteHeader — column header for a single site in the
 * Comparison grids. Shows the site name (truncated), the lead photo
 * (when present), and the geocode status pill.
 *
 * Linear: MYD-217 (F2).
 */

import { Building2 } from 'lucide-react'
import { cn } from 'lib/utils'

const STATUS_COLORS: Record<string, string> = {
	GEOCODED: 'bg-green-100 text-green-700',
	PENDING: 'bg-amber-100 text-amber-700',
	FAILED: 'bg-red-100 text-red-700',
}

interface ComparisonSiteHeaderProps {
	site: any
}

const ComparisonSiteHeader = ({ site }: ComparisonSiteHeaderProps) => {
	const photo = site?.coverImage || site?.imageUrls?.[0]
	const status = site?.geocodeStatus || 'PENDING'
	return (
		<div className="bg-gray-50 border-b border-gray-200 border-l first:border-l-0 px-3 py-2.5">
			<div className="flex items-center gap-2 mb-1.5">
				{photo ? (
					<img
						src={photo}
						alt=""
						className="w-7 h-7 rounded object-cover bg-gray-100 shrink-0"
						loading="lazy"
					/>
				) : (
					<div className="w-7 h-7 rounded bg-gray-100 flex items-center justify-center shrink-0">
						<Building2 className="w-3.5 h-3.5 text-gray-400" />
					</div>
				)}
				<h4
					className="text-sm font-semibold text-gray-900 truncate"
					title={site.name}
				>
					{site.name}
				</h4>
			</div>
			<span
				className={cn(
					'inline-block text-[10px] uppercase tracking-wide font-medium px-1.5 py-0.5 rounded',
					STATUS_COLORS[status] ?? STATUS_COLORS.PENDING,
				)}
			>
				{status.toLowerCase()}
			</span>
		</div>
	)
}

export default ComparisonSiteHeader
